/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';

import { Box } from '@chakra-ui/react';

// import { Download } from 'assets/assetsV1/iconComponents';

import { sendExpandedChartEvent } from 'constants/mixpanelHelper';

// import { Button } from 'uiToolkitV1/Button';
import { ExpandableContainerProvider } from 'uiToolkitV1/ExpandableContainerProvider';
import { PaperWithShadow } from 'uiToolkitV1/Paper';
import { TextBodyLarge } from 'uiToolkitV1/Typography';

import DisciplinaryActionsNotesGraph from './DisciplinaryActionsNotesGraph';

type DisciplinaryActionsChartContainerProps = {
  title: string;
  reportType: string;
  data: any;
};

// eslint-disable-next-line arrow-body-style
const DisciplinaryActionsChartContainer = ({ title, data, reportType }: DisciplinaryActionsChartContainerProps) => {
  // const downloadChartImage = () => {};
  const [isExpanded, setIsExpanded] = useState(false);

  const onExpand = () => {
    setIsExpanded(true);
  };

  const onShrink = () => {
    setIsExpanded(false);
  };

  return (
    <PaperWithShadow w="calc(50% - 8px)" p={0} h="100%">
      <ExpandableContainerProvider
        id="disciplinaryActionExpandableChart"
        isParentDeterminesHeight
        toggleBtnBoxProps={{ top: '4px !important', right: '4px !important' }}
        onExpand={onExpand}
        onShrink={onShrink}
      >
        <Box p={4}>
          <Box mb="16px" display="flex" flexDirection="row" justifyContent="space-between">
            <TextBodyLarge bold>{title}</TextBodyLarge>
            {/* <Button variant="tertiary" EndIcon={Download} onClick={downloadChartImage} m="-12px" mr="30px" /> */}
          </Box>
          <DisciplinaryActionsNotesGraph data={data} reportType={reportType} isExpanded={isExpanded} />
        </Box>
      </ExpandableContainerProvider>
    </PaperWithShadow>
  );
};

export default DisciplinaryActionsChartContainer;
